import { required } from 'AppReact/schema';

export const defaultTransferFromState = {
    isOpen: false,
    id: 1
}

export default {
    isOpen: required('boolean'),
    id: required('integer')
}
